import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { Title, Header } from 'components/Common';
import { Button } from '@cloudez/cloudez-design-system';

import axios from 'axios';
import history from 'services/history';

import { useAuth } from 'hooks/auth';

import { refreshBankslipExternalService } from 'services/invoice';
import toastError from 'utils/toastError';
import { Iframe, Wrapper, SpinnerIcon } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const InvoiceBankslip = ({ match }) => {
  const [billing, setBilling] = useState(null);
  const [bankslip, setBankslip] = useState(null);

  const [externalUrl, setExternalUrl] = useState(null);

  const { user } = useAuth();

  useEffect(() => {
    const { hash } = match.params;

    async function getInvoice() {
      try {
        const apiUrl =
          window.location.hostname === 'demo.cloudez.io'
            ? 'https://dev-api.cloudez.io/'
            : process.env.REACT_APP_API_URL
            ? process.env.REACT_APP_API_URL
            : 'https://api.cloudez.io/';

        const { data } = await axios.get(`${apiUrl}v2/invoice-hash/${hash}/`);

        const { fbq } = window as any;
        const { gtag } = window as any;

        if (fbq) {
          fbq('track', 'Purchase', {
            currency: data.total.currency,
            value: data.total.amount,
          });
        }

        if (gtag) {
          gtag('event', 'track', { event_category: 'Purchase' });
        }

        const today = moment();
        const expiredAt = moment(data?.expired_at);
        const isExpired = expiredAt.isBefore(today, 'days');

        const startChargingAt = moment(data?.start_charging_at).format(
          'YYYY-MM-DD',
        );

        const maxDate = moment(data?.start_charging_at)
          .add(10, 'days')
          .format('YYYY-MM-DD');

        const canChangeDate =
          isExpired &&
          data?.has_gateway &&
          !data?.is_paid &&
          moment().isBetween(startChargingAt, maxDate, null, '[]');

        if (canChangeDate) {
          try {
            await refreshBankslipExternalService(hash);
          } catch (e) {
            // não regerou o boleto: mostra o motivo e manda pra escolha da forma de pagamento
            toastError(e);
            history.push(`/invoices/external/${hash}`);
            return;
          }
          await getBankslip();
        } else if (data.is_paid) {
          history.push(`/invoices/${data.id}`);
        }
      } catch (e) {
        history.push(`/404`);
      }
    }

    async function getBilling() {
      try {
        const apiUrl =
          window.location.hostname === 'demo.cloudez.io'
            ? 'https://dev-api.cloudez.io/'
            : process.env.REACT_APP_API_URL
            ? process.env.REACT_APP_API_URL
            : 'https://api.cloudez.io/';

        const { data } = await axios.get(`${apiUrl}v3/billing-hash/${hash}/`);

        setBilling(data);
      } catch (e) {
        history.push(`/invoices/external/${hash}`);
      }
    }

    async function getBankslip() {
      try {
        const apiUrl =
          window.location.hostname === 'demo.cloudez.io'
            ? 'https://dev-api.cloudez.io/'
            : process.env.REACT_APP_API_URL
            ? process.env.REACT_APP_API_URL
            : 'https://api.cloudez.io/';

        const { data } = await axios.get(`${apiUrl}v0/bank-slip/${hash}/`, {
          responseType: 'blob',
        });

        const response = await axios.get(`${apiUrl}v0/bank-slip/${hash}/`, {
          responseType: 'json',
        });

        setExternalUrl(response.data);

        setBankslip(URL.createObjectURL(data));
      } catch (e) {
        history.push(`/invoices/external/${hash}`);
      }
    }

    getInvoice();
    if (!billing) getBilling();
    if (!bankslip) getBankslip();
    // eslint-disable-next-line
  }, []);

  const apiUrl =
    window.location.hostname === 'demo.cloudez.io'
      ? 'https://dev-api.cloudez.io/'
      : process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL
      : 'https://api.cloudez.io/';

  return billing && bankslip ? (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 0px 40px 0px',
        }}
      >
        <Title>Boleto</Title>

        {user?.payment_gateway !== 'PagBrasil' ||
          (!externalUrl.url_boleto?.includes('pagbrasil') && (
            <Button>
              <a
                href={`${apiUrl}v0/bank-slip/${match.params.hash}/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </a>
            </Button>
          ))}
      </div>

      <Iframe
        src={
          user?.payment_gateway === 'PagBrasil' ||
          externalUrl.url_boleto?.includes('pagbrasil')
            ? externalUrl.url_boleto
            : `${bankslip}#statusbar=0`
        }
      />

      <Button
        style={{
          marginTop: '16px',
          width: '300px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
        onClick={() => history.push(`/invoices/external/${match.params.hash}`)}
      >
        Alterar forma de pagamento
      </Button>
    </>
  ) : (
    <Wrapper>
      <div className="loading">
        <SpinnerIcon icon={faSpinner} spin size="3x" />
        <Title
          style={{
            marginTop: '20px',
          }}
        >
          Carregando boleto...
        </Title>
      </div>
    </Wrapper>
  );
};

export default InvoiceBankslip;
